import { render, staticRenderFns } from "./zorder.vue?vue&type=template&id=7822b87c&scoped=true"
import script from "./zorder.vue?vue&type=script&lang=js"
export * from "./zorder.vue?vue&type=script&lang=js"
import style0 from "./zorder.vue?vue&type=style&index=0&id=7822b87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7822b87c",
  null
  
)

export default component.exports